<template>
  <button class="filters__select-boxes-row" :class="{'filters__select-boxes-row--active': isActive}" v-on:click="handleClick">
    <span class="filters__select-boxes-row__label">{{label}}</span>
  </button>
</template>

<script type="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BoxesRow extends Vue {
  @Prop({default: null}) id: number | string;
  @Prop({default: null, type: String}) label: string;
  @Prop({default: null, type: String}) icon: string;
  @Prop({default: 'white', type: String}) color: string;
  @Prop({default: false}) isActive: boolean;

  public handleClick() {
    this.$emit('select', this.id);
  }
}
</script>